import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import type { RealtimeChannel } from "@supabase/supabase-js";

export function useTournamentRealtime(
  tournamentId: string | null,
  onUpdate: () => void,
) {
  useEffect(() => {
    if (!tournamentId) return;

    let channel: RealtimeChannel;

    const setupRealtime = () => {
      // Subscribe to tournament_participants changes for this tournament
      channel = supabase
        .channel(`tournament:${tournamentId}`)
        .on(
          "postgres_changes",
          {
            event: "*", // INSERT, UPDATE, DELETE
            schema: "public",
            table: "tournament_participants",
            filter: `tournament_id=eq.${tournamentId}`,
          },
          (payload) => {
            console.log("Tournament participant change:", payload);
            // Refresh tournament data when participants change
            onUpdate();
          },
        )
        .on(
          "postgres_changes",
          {
            event: "UPDATE",
            schema: "public",
            table: "tournaments",
            filter: `id=eq.${tournamentId}`,
          },
          (payload) => {
            console.log("Tournament status change:", payload);
            // Refresh when tournament status changes (upcoming → active → completed)
            onUpdate();
          },
        )
        .subscribe();
    };

    setupRealtime();

    return () => {
      if (channel) {
        supabase.removeChannel(channel);
      }
    };
  }, [tournamentId, onUpdate]);
}

export function useTournamentsListRealtime(onUpdate: () => void) {
  useEffect(() => {
    // Subscribe to all tournament changes
    const channel = supabase
      .channel("tournaments-list")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tournaments",
        },
        (payload) => {
          console.log("Tournaments list change:", payload);
          onUpdate();
        },
      )
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tournament_participants",
        },
        (payload) => {
          console.log("Tournament participants change:", payload);
          onUpdate();
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [onUpdate]);
}
